export default __webpack_public_path__ + "static/media/I_wdt_c_cap_1.b000545d.mp3";